export const tempLangConverter = (lang) => {
    switch (lang) {
        case "swe":
            return 'se'
        case "nor":
            return 'no'
        case "eng":
            return 'gb'

        default:
            break;
    }
}
